document.addEventListener('click', function (e) {
  if (!(e.target instanceof Element)) return;
  const link = e.target.closest('.menu-list__link');
  if (!link) return;
  const href = link.getAttribute('href');
  if (href && href.includes('/collections')) {
    e.preventDefault();
  }
});

// ─── Mobile mega-menu panel ────────────────────────────────────────────────
(function () {
  // Inject styles once
  function injectStyles() {
    if (document.getElementById('mobile-mega-panel-styles')) return;
    const s = document.createElement('style');
    s.id = 'mobile-mega-panel-styles';
    s.textContent = `
      .mm-panel {
        position: fixed;
        inset: 0;
        z-index: 99999;
        background: var(--color-background, #fff);
        color: var(--color-foreground, #111);
        display: flex;
        flex-direction: column;
        overflow: hidden;
        transform: translateX(100%);
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      }
      .mm-panel.mm-panel--open {
        transform: translateX(0);
      }

      /* ── Header ── */
      .mm-panel__header {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 14px 18px;
        border-bottom: 1px solid var(--color-border, #e8e8e8);
        position: sticky;
        top: 0;
        background: var(--color-background, #fff);
        z-index: 1;
        flex-shrink: 0;
      }
      .mm-panel__back {
        display: flex;
        align-items: center;
        gap: 6px;
        background: none;
        border: none;
        cursor: pointer;
        padding: 6px;
        margin-left: -6px;
        color: inherit;
        font-size: 14px;
        font-family: inherit;
        min-height: 44px;
      }
      .mm-panel__back svg { flex-shrink: 0; }
      .mm-panel__title {
        font-size: 17px;
        font-weight: 600;
        font-family: var(--font-heading--family, inherit);
        letter-spacing: 0.01em;
      }

      /* ── Tabs row ── */
      .mm-panel__tabs {
        display: flex;
        gap: 8px;
        padding: 12px 18px;
        overflow-x: auto;
        scrollbar-width: none;
        flex-shrink: 0;
        border-bottom: 1px solid var(--color-border, #e8e8e8);
      }
      .mm-panel__tabs::-webkit-scrollbar { display: none; }
      .mm-panel__tab {
        flex-shrink: 0;
        padding: 8px 18px;
        border-radius: 999px;
        border: 1px solid var(--color-border, #ccc);
        background: transparent;
        cursor: pointer;
        font-size: 13px;
        color: inherit;
        font-family: inherit;
        transition: background 0.18s, color 0.18s, border-color 0.18s;
        min-height: 36px;
      }
      .mm-panel__tab.mm-panel__tab--active {
        background: #4e6b63;
        color: #fff;
        border-color: #4e6b63;
      }

      /* ── Card grid ── */
      .mm-panel__body {
        flex: 1;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        padding: 16px 18px 32px;
      }
      .mm-panel__pane {
        display: none;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
      }
      .mm-panel__pane.mm-panel__pane--active {
        display: grid;
      }
      .mm-panel__card {
        display: flex;
        flex-direction: column;
        text-decoration: none;
        color: inherit;
        border-radius: 10px;
        overflow: hidden;
        border: 1px solid var(--color-border, #eee);
        transition: box-shadow 0.2s;
      }
      .mm-panel__card:active { box-shadow: 0 2px 8px rgba(0,0,0,0.1); }
      .mm-panel__card-thumb {
        width: 100%;
        aspect-ratio: 1;
        background: #f5f5f5;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      }
      .mm-panel__card-thumb img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
      .mm-panel__card-thumb svg { opacity: 0.25; }
      .mm-panel__card-label {
        font-size: 12px;
        font-weight: 600;
        line-height: 1.3;
        padding: 8px 8px 10px;
        margin: 0;
      }
    `;
    document.head.appendChild(s);
  }

  var PLACEHOLDER_SVG =
    '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor"' +
    ' stroke-width="1" stroke-linecap="round" stroke-linejoin="round">' +
    '<rect x="3" y="3" width="18" height="18" rx="2"/>' +
    '<circle cx="9" cy="9" r="2"/>' +
    '<path d="m21 15-3-3a2 2 0 0 0-3 0L6 21"/></svg>';

  var BACK_ICON =
    '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor"' +
    ' stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M11 14L6 9l5-5"/></svg>';

  /**
   * @param {Element} megaWrapper
   * @param {string} title
   */
  function buildPanel(megaWrapper, title) {
    injectStyles();

    // Remove stale panel
    var old = document.getElementById('mm-panel');
    if (old) old.remove();

    var tabs  = Array.from(megaWrapper.querySelectorAll('[data-tab]'));
    var panes = Array.from(megaWrapper.querySelectorAll('[data-panel]'));

    var panel = document.createElement('div');
    panel.id = 'mm-panel';
    panel.className = 'mm-panel';

    // ── Header ──
    var header = document.createElement('div');
    header.className = 'mm-panel__header';

    var backBtn = document.createElement('button');
    backBtn.type = 'button';
    backBtn.className = 'mm-panel__back';
    backBtn.setAttribute('aria-label', 'Back');
    backBtn.innerHTML = BACK_ICON + ' Back';
    backBtn.addEventListener('click', function () { closePanel(panel); });
    header.appendChild(backBtn);

    var titleEl = document.createElement('span');
    titleEl.className = 'mm-panel__title';
    titleEl.textContent = title;
    header.appendChild(titleEl);
    panel.appendChild(header);

    // ── Tabs ──
    var tabsRow = document.createElement('div');
    tabsRow.className = 'mm-panel__tabs';
    tabs.forEach(function (src, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mm-panel__tab' + (i === 0 ? ' mm-panel__tab--active' : '');
      btn.textContent = src.textContent.trim();
      btn.dataset.idx = String(i);

      // If the source tab has a navigation onclick (e.g. "All Products"), wire it up
      var onclickAttr = src.getAttribute('onclick') || '';
      var navMatch = onclickAttr.match(/window\.location\.href\s*=\s*['"]([^'"]+)['"]/);
      if (navMatch) {
        btn.dataset.navUrl = navMatch[1];
      }

      tabsRow.appendChild(btn);
    });
    panel.appendChild(tabsRow);

    // ── Body / panes ──
    var body = document.createElement('div');
    body.className = 'mm-panel__body';

    panes.forEach(function (srcPane, i) {
      var pane = document.createElement('div');
      pane.className = 'mm-panel__pane' + (i === 0 ? ' mm-panel__pane--active' : '');
      pane.dataset.idx = String(i);

      srcPane.querySelectorAll('a[href]').forEach(function (/** @type {Element} */ srcCard) {
        var a = document.createElement('a');
        a.className = 'mm-panel__card';
        a.href = srcCard.getAttribute('href') || '#';

        var thumb = document.createElement('div');
        thumb.className = 'mm-panel__card-thumb';
        var img = srcCard.querySelector('img');
        if (img) {
          var ni = document.createElement('img');
          ni.src = img.src;
          ni.alt = img.alt || '';
          ni.loading = 'lazy';
          thumb.appendChild(ni);
        } else {
          thumb.innerHTML = PLACEHOLDER_SVG;
        }
        a.appendChild(thumb);

        var nameEl = srcCard.querySelector('h4, [class*="card-title"]');
        if (nameEl) {
          var p = document.createElement('p');
          p.className = 'mm-panel__card-label';
          p.textContent = nameEl.textContent.trim();
          a.appendChild(p);
        }

        pane.appendChild(a);
      });

      body.appendChild(pane);
    });
    panel.appendChild(body);

    // ── Tab switching ──
    tabsRow.addEventListener('click', function (e) {
      if (!(e.target instanceof Element)) return;
      var btn = /** @type {HTMLElement|null} */ (e.target.closest('.mm-panel__tab'));
      if (!btn) return;

      // Navigate immediately if this tab has a URL (e.g. "All Products")
      if (btn.dataset.navUrl) {
        closePanel(panel);
        window.location.href = btn.dataset.navUrl;
        return;
      }

      var idx = btn.dataset.idx;
      tabsRow.querySelectorAll('.mm-panel__tab').forEach(function (t) {
        var ht = /** @type {HTMLElement} */ (t);
        ht.classList.toggle('mm-panel__tab--active', ht.dataset.idx === idx);
      });
      body.querySelectorAll('.mm-panel__pane').forEach(function (p) {
        var hp = /** @type {HTMLElement} */ (p);
        hp.classList.toggle('mm-panel__pane--active', hp.dataset.idx === idx);
      });
    });

    document.body.appendChild(panel);
    return panel;
  }

  /** @param {HTMLElement} panel */
  function closePanel(panel) {
    panel.classList.remove('mm-panel--open');
    setTimeout(function () { panel.remove(); }, 320);
  }

  // ── Intercept drawer tap ──
  document.addEventListener('click', function (e) {
    if (window.innerWidth >= 750) return;
    if (!(e.target instanceof Element)) return;

    var drawerItem = e.target.closest('.menu-drawer__menu-item--mainlist');
    if (!drawerItem) return;

    var itemText = drawerItem
      .querySelector('.menu-drawer__menu-item-text')
      ?.textContent?.trim();
    if (!itemText) return;

    var megaWrapper = document.querySelector('[data-mega-menu-target="' + itemText + '"]');
    if (!megaWrapper) return;

    e.preventDefault();

    var panel = buildPanel(megaWrapper, itemText);

    // Close drawer
    var headerDrawer = /** @type {any} */ (document.querySelector('header-drawer'));
    if (headerDrawer && typeof headerDrawer.close === 'function') {
      headerDrawer.close();
    }

    // Trigger slide-in on next two frames so transform starts from translateX(100%)
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.classList.add('mm-panel--open');
      });
    });
  });
})();
